import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import makeStyles from '@material-ui/styles/makeStyles';
import moment from 'moment';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import MetricTooltip from 'components/MetricTooltip/MetricTooltip';
import { formatNumberWithThinSpaces } from 'helpers/helpers';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    columnGap: '32px',
    rowGap: '8px',
    flexWrap: 'wrap',
    marginTop: '20px',
    marginBottom: '-20px',
    minHeight: '24px',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '400',
    cursor: 'default',
  },
  value: {
    backgroundColor: grayColor[13],
    borderRadius: '4px',
    fontWeight: '500',
    padding: '3px 5px',
  },
  emptyValue: {
    fontWeight: '400',
  },
});

const MetricsLegend = ({ datasets, valueUnit }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      {datasets.map((dataSet, index) => {
        const { total } = dataSet.legendLabel;
        const isNoDataLabelShown = total === null;
        const value = isNoDataLabelShown
          ? t('dashboard.metrics.noData')
          : `${formatNumberWithThinSpaces(dataSet.legendLabel.total)}${
              valueUnit ? ` ${valueUnit}` : ''
            }`;

        return (
          <MetricTooltip
            key={dataSet.legendLabel.year}
            color={dataSet.borderColor}
            title={dataSet.tooltipTitle}
            isDisabled={isNoDataLabelShown}
            content={[
              {
                text: dataSet.legendLabel.datesRange
                  .reduce(
                    (acc, date) =>
                      acc.some(d => moment(d).isSame(date, 'day'))
                        ? acc
                        : [...acc, date],
                    []
                  )
                  .map(date => moment(date).format('DD.MM.YYYY'))
                  .join(' - '),
              },
              {
                highlightedText: value,
                text: dataSet.getValueSuffix(dataSet.legendLabel.total),
              },
            ]}
          >
            <div className={classes.label}>
              <div
                style={
                  index === 0
                    ? {
                        width: '22px',
                        borderTop: `3px solid ${dataSet.borderColor}`,
                      }
                    : {
                        width: '24px',
                        height: '3px',
                        borderLeft: `8px solid ${dataSet.borderColor}`,
                        borderRight: `8px solid ${dataSet.borderColor}`,
                      }
                }
              />
              <span>
                {moment(dataSet.legendLabel.datesRange[0]).year()}{' '}
                {t('$*common.yearAbbreviation')}
              </span>
              <div
                className={classNames(
                  classes.value,
                  isNoDataLabelShown && classes.emptyValue
                )}
              >
                {value}
              </div>
            </div>
          </MetricTooltip>
        );
      })}
    </div>
  );
};

export default MetricsLegend;
